import VND from "../../components/VND";
import SelectFromList from "../../components/SelectFromList";
import SLink from "../../components/SLink";
import { useState } from "react";
import Staff from "../../components/Staff";
import Lang from "../../components/Lang";
import useCTX from "../../hooks/useCTX";
import Text from "../../components/Text";
import Customer from "../customer/Customer";
/* import CheckAttendance from "../Check attendance/CheckAttendance"; */
import Tooltip from "@mui/material/Tooltip";
import Link from "@mui/material/Link";
import HtClass from "../../components/HtClass";
import { Link as RouterLink } from "react-router-dom";



export default function DrawNewStudent({ student }) {
  const [consultant, setConsultant] = useState(student.consultant || "")
  const { getStaffRole } = useCTX()
  const [notes,setNotes] = useState(student.consultantNotes && student.consultantNotes.consultantNotes ? student.consultantNotes.consultantNotes : "")
  

return (
  <div
    style={{
      display: "flex",
      marginBottom: 5,
      alignItems: "center",
      gap: 10,
      flexWrap: "wrap",
    }}
  >
    <div style={{ width: 300, minWidth: 300 }}>
      <SLink
        id={student._id}
        showClasses
        status
        showTeacher
      />
    </div>

    <Customer customer={student.customer} />

    <div style={{ width: 120 }}>
      <div>{new Date(student.latestStartDate).fDate()}</div>
      <div style={{ fontSize: 9, color: "#888" }}>
        <Staff id={student.changedBy} />
      </div>
    </div>
    <div style={{ width: 120 }}>
      <div>{new Date(student.firstClassDate).fDate()}</div>
     {/* <CheckAttendance student={student} /> */}
    </div>
    <div style={{ width: 200, fontSize: 12 }}>
      <Text
        value={notes}
        setValue={setNotes}
        placeholder="Consultant notes"
        fontSize={12}
        multiline
        rows={2}
        url={`/update-consultant-notes/${student.phone}`}
        field="notes"
        size="small"
     
        style={{ width: 200, minWidth: 200, marginBottom: 5 }}
      />
    </div>
    <DrawAttendance student={student} />

    <Bills
      bills={student.bills}
      scholarship={student.scholarship}
    />

    <SelectFromList
      value={consultant}
      setValue={setConsultant}
      choices={getStaffRole("Sales").sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      )}
      url={`/student/${student._id}`}
      field="consultant"
      size="small"
      style={{ width: 200 }}
    />
  </div>
);
}

function DrawAttendance({ student }) {
  
  return (
    <div
      style={{
        width: 270,
        minWidth: 150,
        display: "flex",
        gap: 3,
        flexWrap: "wrap",
        alignItems: "center",
        marginLeft: 10,
      }}
    >
      {student.attendances.slice(-8).map((attendance) => {
        let background = "green";
        if (attendance.attendance === -1) background = "limegreen";
        if (attendance.attendance === 2) background = "goldenrod";
        if (attendance.attendance === 3) background = "red";

       

        return (
          <Tooltip
            title={<Title attendance={attendance} />}
            key={attendance._id}
          >
            <div
              style={{
                width: 30,
                height: 30,
                background,
                fontSize: 9,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontWeight: "bold",
                borderRadius: 5,
                cursor: "pointer",
              }}
            >
              {new Date(attendance.tDate).getDate()}/
              {new Date(attendance.tDate).getMonth() + 1}
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
}

function Title({ attendance }) {
   const { findStaff } = useCTX();
   const member =
     attendance.attendance < 2
       ? findStaff(attendance.teacher)
       : findStaff(attendance.recordedBy);
  const reason = attendance.absentReason || <Lang w="noReasonRecorded" />;
  let dt = "Attendance not recorded";
  if (attendance.attendance < 2) {
    attendance.feedbackComplete
      ? dt = new Date(attendance.feedbackComplete).fDateTime()
      : dt = "No feedback";
  } else {
    dt = new Date(attendance.updatedAt).fDateTime()
  }
  
  return (
    <>
      <div style={{display:"flex", justifyContent: "space-between", minWidth: 200}}>
        <div style={{ fontWeight: "bold", color: "yellow" }}>
          {member ? member.name : `No one`}:
        </div>
        <div>{dt}</div>
      </div>
      <div>{attendance.attendance < 2 ? attendance.notes : reason}</div>
    </>
  );
}


function Attendance({ attendance }) {
  if(!attendance) return <></>
  let colors = ["#007874", "#038722", "#ffae00", "#ff0055"];
  const backgroundColor = attendance.attendance>0 ? colors[attendance.attendance] : "Limegreen"
  return <div style={{ backgroundColor, color: "white", width: 200, minHeight: 100, borderRadius: "0.5rem", padding: 10, fontSize: 12 }}>
    <Staff id={attendance.teacher} />
    <hr />
    {attendance.notes}
  </div>
}


function Bills({ bills,scholarship }) {
  
  if(scholarship) return <div style={{ color:"green", width: 150 }}>Scolarship</div>;

  if (!bills || bills.length === 0) return <div style={{ color: "red",width:150 }}>No bills</div>
  let color = "green"
  for (let bill of bills) {
    if(!bill.paymentId) color="black"
  }
  return (
    <div style={{ color, width: 150 }}>
      {" "}
      <VND value={bills.reduce((a, b) => a + b.amount, 0)} />
    </div>
  );
}

function CustomerInfo({ customer }) {
  
  return (
    <div style={{ width: 150 }}>
      <div>{<Link to={`/customer/${customer._id}`} className="neat">{customer.name}</Link> || "Unknown"}</div>
      <div style={{ fontSize: 9, color: "#888", margin: 0 }}>
        {customer.marketingSource || "Unkown source"}
      </div>
    </div>
  );
}

function AttendanceStatus({ student }) {
  const style={fontSize:9, color:"#888"}
  if (new Date().tDate() < new Date(student.firstClassDate).tDate()) return <div style={{ ...style }}><Lang w="waiting" />...</div>
  const attendance = student.attendances.find(a => a.tDate === new Date(student.firstClassDate).tDate());
  if(!attendance) return <div style={{ ...style, color:"red", fontWeight:"bold" }}><Lang w="notRecorded" /></div>;
  if (attendance.attendance < 2) {
    return <div style={{ ...style, color:"green"}}><Lang w="attended" /></div>;
  }
  return <div style={{ ...style, color:"red" }}><Lang w="didntAttend" /></div>;
}